/*global jQuery, $ */

var $link;
var delayTimer;

function getVisibility() {
  return $(window).scrollTop() < ($(window).height() / 2);
}

function updateVisibilityImmediately() {
  $link.toggleClass('hide', getVisibility());
}

function updateVisibility() {
  if (delayTimer) {
    clearTimeout(delayTimer);
  }

  delayTimer = setTimeout(updateVisibilityImmediately, 100);
}

function backToTop() {
  $link.addClass('hide');

  $('body, html').animate({scrollTop: 0}, 100);
}

$(() => {
  $link = $('<a href="#" class="back-to-top-link hide"><i class="fa fa-arrow-up"></i> トップへ</a>')
    .appendTo($(document.body))
    .on('click', (e) => {
      e.preventDefault();

      backToTop();
    });

  $(window).on('scroll', () => {
    updateVisibility();
  });

  updateVisibility();
});

// export class BackToTop {
//   constructor() {
//     this.$link = this.buildLink();
//     this.scrollTimer = null;
//     this.scrollEventHandler = null;
//
//     $link = $('<a href="#" class="back-to-top-link hide">トップへ</a>')
//       .appendTo($(document.body))
//   }
//
//   buildLink() {
//     return $('<a href="#" class="back-to-top-link hide">トップへ</a>')
//       .on('click', function (e) {
//         e.preventDefault();
//
//         $('body, html').animate({scrollTop: 0}, 100);
//       });
//   }
//
//   getVisibility() {
//     return $(window).scrollTop() < ($(window).height() / 3);
//   }
//
//   updateVisibility() {
//     this.$link.toggleClass('hide', this.getVisibility());
//   }
//
//   scrollEventHandler() {
//
//     if (this.scrollTimer) {
//       clearTimeout(this.scrollTimer);
//     }
//
//     this.scrollTimer = setTimeout(() => {
//       this.updateVisibility();
//     }, 100);
//   }
//
//   start() {
//     this.$link.appendTo(document.body);
//
//     $(window).on('scroll', () => { this.scrollEventHandler(); });
//
//     this.updateVisibility();
//   }
//
//   stop() {
//     this.$link.remove();
//
//     $(window).off('scroll', this.scrollEventHandler);
//   }
// }
